import React from "react";
import styles from "./style.module.css";

export default class BalanceLegend extends React.PureComponent {
  render() {
    const { pData, total, reverse } = this.props;
    if (!pData) {
      return <React.Fragment />;
    }
    return (
      <div className={styles.balanceLegendWrapper}>
        {pData.map((data, i) => (
          <LegendItem key={data.name} data={data} total={total} reverse={reverse} />
        ))}
      </div>
    );
  }
}

class LegendItem extends React.PureComponent {
  render() {
    const { data, total, reverse } = this.props;
    return (
      <div className={styles.legendItemWrapper} style={{ flexDirection: reverse ? "row-reverse" : "row" }}>
        <div
          className={styles.legendItemCircle}
          style={{
            background: data.color + (data.isOutline ? +"88" : ""),
            borderColor: data.color
          }}
        />
        <div className={styles.legendItemText} style={{ textAlign: reverse ? "right" : "left" }}>
          {data.name + (total ? " (" + Math.round((data.value / total) * 100) + "%)" : "")}
        </div>
      </div>
    );
  }
}
